import { Pipe, PipeTransform } from '@angular/core';
import { SEX_LANG_PIPE_I18N } from './sex-lang.pipe.i18n';

@Pipe({
    standalone: true,
    name: 'sexLang',

})
export class SexLangPipe implements PipeTransform {
  transform(value: string, language: string): string {
    let sex: string;

    switch (value) {
      case 'female':
        sex = language === 'jp' ? SEX_LANG_PIPE_I18N.sex.female : 'Female';
        break;
      case 'male':
        sex = language === 'jp' ? SEX_LANG_PIPE_I18N.sex.male : 'Male';
        break;
      default:
        sex = language === 'jp' ? SEX_LANG_PIPE_I18N.sex.other : 'Other';
        break;
    }

    return sex;
  }
}
